import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
    name: 'global',
    store() {
        return {
            isMobileMenuVisible: false,
            isMinicartVisible: false,
            // isPredictiveSearchVisible: false,
            isWindowScrolled: false,
            cart: null,
            cart_count: 0,
            body: "",
            scrollTopLock: 0,
            showLine: true,

            init() {
                window.addEventListener('scroll', this.onWindowScrollHandler.bind(this))

                const cartOpen = new URLSearchParams(window.location.search).get('open');

                if(cartOpen == 'true') {
                    this.isMinicartVisible = true;
                }

                this.initLiquidAJaxCart();

                if(window.innerWidth > 999) {
                    this.parallax();
                }

                this.body = document.querySelector("body");
            },

            parallax() {
                const elements = document.querySelectorAll(".parallax");
                [...elements].forEach((item) => {
                    let start = item.dataset.paraStart;
                    const el = item.children[0];
        
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: item.closest("section"),
                            start: `${start}`,
                            scrub: true,
                        },
                    }).to(el, {
                         ease: "none",
                        translateY: `-400px`,
                    });
                });
            },

            get bodyClasses() {
                let classes = []

                if (this.isMobileMenuVisible) {
                    classes.push('mobile-menu-visible')
                }
                if (this.isMinicartVisible) {
                    classes.push('cart-visible')
                }
                return classes || ''
            },

            openMobileMenu() {
                this.isMobileMenuVisible = true
                this.enableBodyScrollLock()
            },

            closeMobileMenu() {
                this.isMobileMenuVisible = false
                this.disableBodyScrollLock()
            },

            toggleMobileMenu() {
                this.isMobileMenuVisible = !this.isMobileMenuVisible

                if(this.isMobileMenuVisible) {
                    this.enableBodyScrollLock()
                } else {
                    this.disableBodyScrollLock()
                }
            },

            initLiquidAJaxCart() {
                document.addEventListener("liquid-ajax-cart:init", (event) => {
                    this.cart = window.liquidAjaxCart.cart;
                });

                document.addEventListener("liquid-ajax-cart:request-end", (event) => {
                    const { requestState, cart, previousCart, sections } = event.detail;

                    if (requestState.requestType === 'add') {
                        if (requestState.responseData?.ok) {
                            this.isMinicartVisible = true;
                            this.enableBodyScrollLock();
                        }
                    }
                    this.cart = cart
                    this.cart_count = this.cart.item_count
                });
            },

            onWindowScrollHandler() {
                const isScrolled = window.scrollY > 0

                this.isWindowScrolled = isScrolled
                document.body.classList[isScrolled ? 'add' : 'remove']('scrolled')
            },

            enableBodyScrollLock() {
                this.scrollTopLock =
                    document.documentElement.scrollTop || document.body.scrollTop;
                this.body.style.overflow = "hidden";
                this.body.style.position = "fixed";
                this.body.style.top = `-${this.scrollTopLock}px`;
                this.body.style.width = "100%";
            },
        
            disableBodyScrollLock() {
                this.body.style.removeProperty("overflow");
                this.body.style.removeProperty("position");
                this.body.style.removeProperty("top");
                this.body.style.removeProperty("width");
                window.scrollTo(0, this.scrollTopLock);
            }
        }
    }
}